import { User } from './user/user.js';
import { Content } from './content/content.js';
import { API } from './api/api.js';
import { Actions } from './user/actions.js';
import { Player } from './player/player.js';
import { Nodes } from './player/nodes.js';
import { Cast } from './player/cast.js';
import { Products } from './products/products.js';

export class Base {

  playerEvents = {};
  self = null;

  constructor(options = {}) {
    this.self = this;
    var brand = options.brand || 'default';
    this.api = new API(brand, this.self);
    this.actions = new Actions(brand, this.self);
    this.user = new User(brand, this.self);
    this.content = new Content(brand, this.self);
    this.products = new Products(brand, this.self);
    this.players = [];

    // Iniciamos los nodos
    Nodes.init(this.self.content.staticContentUrl);

    // Si no nos viene disableChromecast, lo activamos
    if (!options.disableChromecast) {
      this.cast = new Cast(this, this.contentId, this.elementSelector, this.options);
    }
  }

  // Método para registrar un evento y su manejador
  on(event, listener) {
    if (!this.playerEvents[event]) {
      this.playerEvents[event] = [];
    }
    this.playerEvents[event].push(listener);
  }

  // Método para emitir un evento y ejecutar todos los manejadores registrados
  emit(event, ...args) {
    if (this.playerEvents[event]) {
      this.playerEvents[event].forEach(listener => listener(...args));
    }
  }

  // Método para eliminar un manejador específico de un evento
  off(event, listenerToRemove) {
    if (!this.playerEvents[event]) return;

    this.playerEvents[event] = this.playerEvents[event].filter(listener => listener !== listenerToRemove);
  }

  async init() {
    await this.content.refresh();
  }

  parseIntegerFields(data, fields) {
    for (let field of fields) {
      if (data[field] !== undefined) {
        data[field] = parseInt(data[field]);
      }
    }
    return data;
  }

  createPlayer(contentId, elementId, options) {
    let player = new Player(this.self, contentId, elementId, options);
    return player;
  }

}